import { LeftOutlined } from '@ant-design/icons';
import { AutoComplete, Button, Col, ColorPicker, DatePicker, Form, Input, InputNumber, Row } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import UploadImg from '../../../components/uploadImage';
import { useAddCars, useCar, useEditCar } from '../../../zustand/store';
import { FormWrapper, GoBackBtn, Wrapper } from './styles';

function CarForm() {
    const [imgList, setImgList] = useState([]);
    const navigate = useNavigate();
    const addCar = useAddCars();
    const editCar = useEditCar();
    let { id } = useParams();
    const car = useCar();
    const [form] = Form.useForm();

    const list = [
        { "label": "Acura", "models": ["MDX", "RDX", "ILX", "TLX", "NSX"] },
        { "label": "Alfa Romeo", "models": ["Giulia", "Stelvio", "4C Spider", "Giulietta"] },
        { "label": "Audi", "models": ["A3", "A4", "A6", "Q3", "Q7", "Q8", "R8"] },
        { "label": "BMW", "models": ["3 Series", "5 Series", "7 Series", "X3", "X5", "X7", "Z4"] },
        { "label": "Buick", "models": ["Enclave", "Encore", "Envision", "LaCrosse"] },
        { "label": "Cadillac", "models": ["CT4", "CT5", "CT6", "XT4", "XT5", "XT6", "Escalade"] },
        { "label": "Chevrolet", "models": ["Cruze", "Malibu", "Impala", "Equinox", "Traverse", "Tahoe", "Silverado"] },
        { "label": "Chrysler", "models": ["300", "Pacifica", "Voyager"] },
        { "label": "Citroën", "models": ["C3", "C4", "C5 Aircross"] },
        { "label": "Dodge", "models": ["Charger", "Challenger", "Durango", "Journey"] },
        { "label": "Fiat", "models": ["500", "500X", "500L"] },
        { "label": "Ford", "models": ["Fiesta", "Focus", "Fusion", "Escape", "Edge", "Explorer", "F-150"] },
        { "label": "Genesis", "models": ["G70", "G80", "G90", "GV70", "GV80"] },
        { "label": "GMC", "models": ["Sierra", "Yukon", "Terrain", "Acadia", "Canyon"] },
        { "label": "Honda", "models": ["Civic", "Accord", "CR-V", "Pilot", "Odyssey", "HR-V"] },
        { "label": "Hyundai", "models": ["Elantra", "Sonata", "Tucson", "Santa Fe", "Kona", "Palisade"] },
        { "label": "Infiniti", "models": ["Q50", "Q60", "QX50", "QX55", "QX80"] },
        { "label": "Jaguar", "models": ["XE", "XF", "XJ", "F-PACE", "E-PACE", "I-PACE"] },
        { "label": "Jeep", "models": ["Cherokee", "Grand Cherokee", "Wrangler", "Compass", "Renegade"] },
        { "label": "Kia", "models": ["Soul", "Seltos", "Sportage", "Niro", "Telluride", "Optima"] },
        { "label": "Land Rover", "models": ["Range Rover", "Discovery", "Defender", "Evoque", "Velar"] },
        { "label": "Lexus", "models": ["IS", "ES", "GS", "RX", "NX", "LX", "UX"] },
        { "label": "Lincoln", "models": ["Nautilus", "Aviator", "Corsair", "Navigator", "MKZ"] },
        { "label": "Maserati", "models": ["Ghibli", "Quattroporte", "Levante", "MC20"] },
        { "label": "Mazda", "models": ["Mazda3", "Mazda6", "CX-5", "CX-9", "MX-5 Miata"] },
        { "label": "McLaren", "models": ["720S", "GT", "Artura", "765LT"] },
        { "label": "Mercedes-Benz", "models": ["A-Class", "C-Class", "E-Class", "S-Class", "GLA", "GLC", "GLE", "SLS"] },
        { "label": "Mini", "models": ["Cooper", "Clubman", "Countryman"] },
        { "label": "Mitsubishi", "models": ["Outlander", "Eclipse Cross", "Mirage", "RVR"] },
        { "label": "Nissan", "models": ["Altima", "Maxima", "Rogue", "Murano", "370Z", "Titan"] },
        { "label": "Pagani", "models": ["Huayra", "Zonda"] },
        { "label": "Porsche", "models": ["911", "Cayenne", "Macan", "Panamera", "718 Boxster"] },
        { "label": "Ram", "models": ["1500", "2500", "3500", "Rebel", "TRX"] },
        { "label": "Rolls-Royce", "models": ["Phantom", "Ghost", "Cullinan", "Wraith", "Dawn"] },
        { "label": "Saab", "models": ["9-3", "9-5"] },
        { "label": "Subaru", "models": ["Impreza", "Legacy", "Outback", "Forester", "Ascent"] },
        { "label": "Suzuki", "models": ["SX4", "Kizashi", "Vitara"] },
        { "label": "Tesla", "models": ["Model S", "Model 3", "Model X", "Model Y"] },
        { "label": "Toyota", "models": ["Camry", "Corolla", "RAV4", "Highlander", "Tacoma", "Land Cruiser", "Supra"] },
        { "label": "Volkswagen", "models": ["Jetta", "Passat", "Tiguan", "Atlas", "Golf", "Arteon"] },
        { "label": "Volvo", "models": ["S60", "S90", "V60", "V90", "XC40", "XC60", "XC90"] }
    ]

    const colors = [
        { label: 'Red', value: 'red' },
        { label: 'Blue', value: 'blue' },
        { label: 'Green', value: 'green' },
        { label: 'Yellow', value: 'yellow' },
        { label: 'Orange', value: 'orange' },
        { label: 'Purple', value: 'purple' },
        { label: 'Pink', value: 'pink' },
        { label: 'Brown', value: 'brown' },
        { label: 'Gray', value: 'gray' },
        { label: 'Black', value: 'black' },
        { label: 'White', value: 'white' },
        { label: 'Cyan', value: 'cyan' },
        { label: 'Magenta', value: 'magenta' },
        { label: 'Lime', value: 'lime' },
        { label: 'Teal', value: 'teal' },
        { label: 'Olive', value: 'olive' },
        { label: 'Maroon', value: 'maroon' },
        { label: 'Navy', value: 'navy' },
        { label: 'Turquoise', value: 'turquoise' },
        { label: 'Violet', value: 'violet' }
    ];


    const [make, setMake] = useState("");

    useEffect(() => {
        if (id) {
            car.execute({
                params: { id }, force: true,
                onSuccess: (res) => {
                    const data = res.data;
                    form.setFieldsValue({
                        make: data.make,
                        model: data.model,
                        color: data.color,
                        year: dayjs(data.year),
                        mileage: data.mileage,
                        price: data.price,
                        note: data.note,
                        addedAt: dayjs(data.addedAt)
                    })
                    setImgList(data.images)
                    console.log(data);
                }

            });
        }
    }, [])

    return (
        <Wrapper>
            <GoBackBtn onClick={() => {
                if (id) {
                    navigate(`/car/${id}`);
                } else {
                    navigate("/");
                }
            }}>
                <LeftOutlined />
            </GoBackBtn>
            <UploadImg imgList={imgList} setImgList={setImgList} />
            <FormWrapper>
                <Form size='large' layout='vertical'
                    form={form}
                    onFinish={(e) => {
                        e.year = e.year.year();
                        e.addedAt = (e.addedAt || dayjs());
                        e.images = imgList.filter(({ photo }) => photo.length).map(({ photo, main }) => ({ photo, main }));
                        e.image = imgList.find(({ main }) => main)?.photo;
                        (id ? editCar : addCar).execute({
                            params: { id },
                            data: e, onSuccess: (res) => {
                                const data = res.data;
                                id = (id || data.id);
                                navigate(`/car/${id}`);
                            }
                        })
                    }}
                >
                    <Form.Item label="Make" name={"make"}
                        rules={[{ required: true }]}
                    >
                        <AutoComplete
                            // style={{ width: 200 }}
                            options={
                                list?.map((v) => ({ label: v.label, value: v.label })) ||
                                []
                            }
                            placeholder="Nissan"
                            onChange={(e) => {
                                setMake(e);
                            }}
                            // filterOption={(inputValue, option) =>
                            //     option?.label?.toUpperCase()?.startsWith(inputValue?.toUpperCase())
                            //     // option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            // }
                            onSelect={(e) => {
                                console.log("Select: ", e);

                                setMake(e);
                            }}
                        />
                    </Form.Item>
                    <Form.Item label="Model" name={"model"}
                        rules={[{ required: true }]}
                    >
                        <AutoComplete
                            // style={{ width: 200 }}
                            options={
                                (list?.find(({ label }) => label === make)?.models || [])
                                    ?.map((v) => ({ label: v, value: v }))
                            }
                            placeholder="Nissan"
                            filterOption={(inputValue, option) =>
                                option.label.toUpperCase().startsWith(inputValue.toUpperCase())
                                // option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        />
                    </Form.Item>
                    <Form.Item label="Color" name={"color"}
                    >
                        <AutoComplete
                            // style={{ width: 200 }}
                            options={
                                (colors || [])
                                    .map((v) => ({ label: <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>{v.label} <ColorPicker value={v.value} size='small' /></div>, value: v?.value }))
                            }
                            placeholder="Green"
                            filterOption={(inputValue, option) =>
                                option?.value?.toUpperCase()?.startsWith(inputValue?.toUpperCase())
                                // option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        />
                    </Form.Item>
                    <Row gutter={15}>
                        <Col span={12}>
                            <Form.Item label="Year" name={"year"}>
                                {/* <Input /> */}
                                <DatePicker
                                    style={{ width: "100%" }}
                                    // onChange={onChange}
                                    picker="year" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Mileage" name={"mileage"}>
                                <InputNumber style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item label="Price" name={"price"}>
                        <InputNumber style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item label="Note" name={"note"}>
                        <Input.TextArea />
                    </Form.Item>
                    <Form.Item label="AddedAt" name={"addedAt"}>
                        <DatePicker format="DD/MMM/YYYY" allowClear={false} defaultValue={dayjs()} style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button type='primary' block htmlType='submit'>
                            {id ? "Update" : "Save"}
                        </Button>
                    </Form.Item>
                </Form>
            </FormWrapper>
        </Wrapper>
    )
}

export default CarForm